import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { EnvironmentService } from '../../core/environment/environment.service';
import { MenuSubMenu } from '../../shared/menu/menu-sub-menu.model';
import { Menu } from '../../shared/menu/menu.model';
import { MenuService } from '../../shared/header/menu/menu.service';


@Injectable({
  providedIn: 'root'
})
export class RecentSearchesService {

  private apiUrl: string;
  recentSearches: Array<MenuSubMenu>;
  recentSearchesSubject: BehaviorSubject<Array<MenuSubMenu>> = new BehaviorSubject<Array<MenuSubMenu>>(null);

  constructor(private http: HttpClient, private environmentService: EnvironmentService, private menuService: MenuService) {
    this.apiUrl = this.environmentService.envModel.appSettings.apiUrlSearch;
  }

  getRecentSearches(userId: number = 1): Observable<Array<MenuSubMenu>> {
    let serviceUrl: string = this.buildServiceUrl(userId);
    return this.http.get<Array<MenuSubMenu>>(this.apiUrl + serviceUrl);
  }

  getUpdatedRecentSearches(): Observable<Array<MenuSubMenu>> {
    this.menuService.getMenu().subscribe((menu: Array<Menu>) => {
      this.recentSearches = this.filterMenuItems(menu);
      this.recentSearchesSubject.next(this.recentSearches);
    });

    return this.recentSearchesSubject.asObservable();
  }

  private filterMenuItems(menu: Array<Menu>): Array<MenuSubMenu> {
    
    let selectedMenuItems: Array<MenuSubMenu> = [];
    let subMenuIndexes = [-15012, -15015, -15017, -11039, -15341];
    let optionalItems = [];

    menu.forEach(menuItem => {
      if (menuItem.categories != null) {
        menuItem.categories.forEach(category => {
          if (category.subMenus != null) {
            category.subMenus.forEach(subMenu => {
              if (subMenuIndexes.includes(subMenu.id))
                selectedMenuItems.push(subMenu);
              else if (optionalItems.length < 5)
                optionalItems.push(subMenu);
            })
          }
        });
      }
    });

    if (selectedMenuItems.length < 5 ) {
      let remainingItems = 5 - selectedMenuItems.length;
      let optionalCount = optionalItems.length;
      if(remainingItems > optionalCount){
        for (let i = 0; i < optionalItems.length; i++) {
          selectedMenuItems.push(optionalItems[i]);
        }
      }
      else{
        for (let i = 0; i < remainingItems; i++) {
          selectedMenuItems.push(optionalItems[i]);
        }
      }
    }

    return selectedMenuItems;
  }

  private buildServiceUrl(userId: number): string {
    return '/api/' + userId + '/recentSearches';
  }

}